const toStorageValue = (value) => {
  if (value === undefined || value === null) return null;
  return String(value);
};

const AsyncStorage = {
  async setItem(key, value) {
    if (!key) return;
    const storageValue = toStorageValue(value);
    if (storageValue === null) {
      window.localStorage.removeItem(key);
      return;
    }
    window.localStorage.setItem(key, storageValue);
  },

  async getItem(key) {
    if (!key) return null;
    return window.localStorage.getItem(key);
  },

  async removeItem(key) {
    if (!key) return;
    window.localStorage.removeItem(key);
  },

  async clear() {
    window.localStorage.clear();
  },

  async multiGet(keys = []) {
    return keys.map((key) => [key, window.localStorage.getItem(key)]);
  },

  async multiSet(entries = []) {
    entries.forEach(([key, value]) => {
      if (!key) return;
      const storageValue = toStorageValue(value);
      if (storageValue === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, storageValue);
    });
  },

  async multiRemove(keys = []) {
    keys.forEach((key) => {
      if (key) window.localStorage.removeItem(key);
    });
  }
};

export default AsyncStorage;
